export const REGULATORY_QUERY_KEYS = {
  regulatoryListFilter: "regulatoryListFilter",
};
